import type { PropsWithChildren } from 'react';

import { useDownloadExport } from './hooks/useDownloadExport';

export function ExportHandler({ children }: PropsWithChildren) {
	useDownloadExport();

	return <>{children}</>;
}
